import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import {fadeIn,wipeOutRight} from '../../app/shared/animation/animation.component';
interface DataItem {
  knowledge_base_id: number;
  question_text: string;
  checked: boolean;
  tag: any;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
}

@Component({
  selector: 'knowledge-base-listing',
  templateUrl: './knowledge-base-listing.component.html',
  animations: [fadeIn,wipeOutRight]
})
export class KnowledgeBaseListingComponent implements OnInit, OnChanges {
  @Input() knowledgeBaseData: any;
  @Output() checkedItemsKnowledgeBase: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  @Input() selectedKnowledgeBaseIds: any;
  @Input() initiallyCheckedKnowledgeBaseIds: number[] = [];
  knowledgeBaseDataRaw: any;
  checkedItems: any[];
  anyChecked: any;
  allChecked: any;
  searchTerm:string;
  listOfColumns: ColumnItem[] = [
    {
      name: 'Knowledge Base',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.question_text.localeCompare(b.question_text),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Tags',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const tagA = a.tag.map((tagObj) => tagObj.tag_name).join(', ');
        const tagB = b.tag.map((tagObj) => tagObj.tag_name).join(', ');
        return tagA.localeCompare(tagB);
      },
      sortDirections: ['ascend', 'descend', null],
    },
  ];
  constructor() {}

  ngOnInit() {
    this.knowledgeBaseDataRaw = this.knowledgeBaseData;
  }

  checkAll(value: boolean): void {
    this.knowledgeBaseData.forEach((data) => {
      data.checked = value;
    });
    this.updateCheckedItems();
  }

  onCheckboxChange(): void {
    this.updateCheckedItems();
  }

  private updateCheckedItems(): void {
    this.checkedItems = this.knowledgeBaseData
      .filter((element) => element.checked)
      .map((element) => element.knowledge_base_id);
    this.anyChecked = this.knowledgeBaseData.some((e) => e.checked);
    this.allChecked = this.knowledgeBaseData.every((e) => e.checked);
    this.checkedItemsKnowledgeBase.emit(this.checkedItems);
  }

  ngOnChanges(changes: SimpleChanges) {}

  // setCheckedItems(idsToCheck: number[]): void {
  //   this.knowledgeBaseData.forEach((item) => {
  //     item.checked = idsToCheck.includes(item.knowledge_base_id);
  //   });
  //   this.checkedItemsKnowledgeBase.emit(this.checkedItems);
  // }

  // resetCheckedItems(): void {
  //   this.checkedItems = [];
  //   this.knowledgeBaseData.forEach((data) => {
  //     data.checked = false;
  //   });
  //   this.anyChecked = false;
  //   this.allChecked = false;
  //   this.checkedItemsKnowledgeBase.emit(this.checkedItems);
  // }

  onKeyUp(query: string): void {
    if (query) {
      let q: string;
      q = query.toLowerCase();
      const searchData = this.knowledgeBaseDataRaw.filter((d) => {
        var found = false;
        d.tag.forEach((tag) => {
          if (tag.tag_name.toLowerCase().includes(q)) {
            found = true;
          }
        });
        if (
          (d.question_text && d.question_text.toLowerCase().includes(q)) ||
          found
        ) {
          return d;
        }
      });
      this.knowledgeBaseData = searchData;
      this.knowledgeBaseData = [...this.knowledgeBaseData];
    } else {
      this.knowledgeBaseData = [...this.knowledgeBaseDataRaw];
    }
  }

  resetSearch(){
    if(this.searchTerm){
      
      this.searchTerm='';
      this.knowledgeBaseData = [...this.knowledgeBaseDataRaw];
    }
  }
  getMoreTagsContent(tags): string[] {
    return tags.slice(2).map((tag) => tag.tag_name);
  }

  moreTagsContent: string[];

  updateMoreTagsContent(tags): void {
    this.moreTagsContent = this.getMoreTagsContent(tags);
  }

  resetMoreTagsContent(): void {
    this.moreTagsContent = [];
  }
}


